import { useModalApiContext } from '@vivli/core/infrastructure/context';

export function useErrorHandling() {
    // Implement your error handling logic here
    const _modalService = useModalApiContext();
    const handleError = (customMessage: string, error?: any) => {
        _modalService.error(`${customMessage} ${error ? `Error received: ${error}` : ``}`);
    };
    return {
        handleError,
    };
}
